module.exports = __webpack_public_path__ + "img/loan_and_biz.9fa46f8f.png";